<template>
  <div>
    <div class="container">
      <div class="row mb-2" v-if="!showAttachmentPrompt">
        <div class="col-sm-2 btn-group">
          <button class="btn btn-outline-primary btn-sm col-6" @click="promptForAttachments(SaveMode.ATTACHMENTS)" v-if="isLinked == 'false' || (hasAttachToMultipleDossiersCapability && isLinked == 'true')"
                  :disabled="isLinking || isUnlinking || isSavingAttachments || isGettingAttOnly || isGettingMailAndAtt" :class="hasNoAttachments ? 'invisible' : 'visible'">
              <i class="fas fa-spin fa-spinner" v-if="isSavingAttachments || isGettingAttOnly"></i>
              <span v-if="!isGettingAttOnly"><i class="fas fa-paperclip"></i> PJ</span>
          </button>

          <button class="btn btn-outline-success btn-sm col-6" @click="promptForAttachments(SaveMode.MAIL)" v-if="isLinked == 'false' || (hasAttachToMultipleDossiersCapability && isLinked == 'true')" :disabled="isLinking || isGettingMailAndAtt || isGettingAttOnly">
              <i class="fas fa-spin fa-spinner" v-if="isLinking || isGettingMailAndAtt"></i>
              <span v-if="!isLinking && !isGettingMailAndAtt"><i class="fas fa-save"></i> Lier</span>
          </button>
        </div>
      </div>
      <Attachments :subfolderPath="subfolderPath" :attachments="attachments" :mode="mode" :isSavingAttachments="isSavingAttachments" :isLinking="isLinking" :mailFilename="mailFilename"
          v-if="showAttachmentPrompt" @update-attachment-name="updateAttachmentName" @hide-attachment-prompt="hideAttachmentPrompt"
          @save-attachments="saveAttachments" @save-mail="linkMail" @update-mail-filename="updateMailFilename" @update-attachments="updateAttachments" />

      <div class="row" v-if="(isLinked == 'false' || (hasAttachToMultipleDossiersCapability && isLinked == 'true')) && showAttachmentPrompt == false">
        <div class="col-md-12">
          <FolderNavigator
            :dossier="$store.state.currentDossier"
            :initial-path="subfolderPath"
            @path-selected="updateSubfolderPathFromNavigator"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Login from './Login.vue';
import Attachments from './Attachments.vue';
import FolderNavigator from './FolderNavigator.vue';
import { Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component'
import LysiasApiMixin from '../mixins/LysiasApiMixin'
import { Dossier, Attachment, SaveMode } from '../interfaces/interfaces'
import sanitize from 'sanitize-filename'

@Component({ components: { Login, Attachments, FolderNavigator } })
export default class Arborescence extends mixins(LysiasApiMixin)
{
  private repertoires: string[] = [];
  private subfolderPath = "";
  private isLoading = false;
  private isLinking = false;
  private isGettingAttachments = false;
  private isSavingAttachments = false;
  private showAttachmentPrompt = false;
  private attachments: Attachment[] = [];
  private success = "";
  private error = "";
  private mode = "";
  private SaveMode = SaveMode;
  private mailFilename = "";

  @Prop({ default: 'false' }) readonly isLinked!: string;


  async mounted()
  {
    console.log(this.isLinked);
    const mail = Office.context.mailbox.item;
    this.mailFilename = mail!.subject;
  }

  get hasNoAttachments()
  {
    const mail = Office.context.mailbox.item;
    return mail!.attachments.length == 0 || mail!.attachments.filter((a: Office.AttachmentDetails) => !this.isQuickSignatureCheck(a)).length == 0;
  }

  get isGettingAttOnly()
  {
    return this.isGettingAttachments && this.mode == this.SaveMode.ATTACHMENTS;
  }

  get isGettingMailAndAtt()
  {
    return this.isGettingAttachments && this.mode == this.SaveMode.MAIL;
  }

  updateSubfolderPath(repertoire: string)
  {
    if(repertoire == "..")
    {
      this.subfolderPath = this.subfolderPath.substring(0, this.subfolderPath.lastIndexOf('/'));
    }
    else
    {
      this.subfolderPath += "/" + repertoire;
    }

    this.subfolderPath = this.subfolderPath.replace(/^\/|\/$/g, '');
  }

  async promptForAttachments(mode: string)
  {
    this.mode = mode;
    const mail = Office.context.mailbox.item;
    this.isGettingAttachments = true;
    try
    {
      this.attachments = await this.getAttachments(mail!);
      for(let attachment of this.attachments)
      {
        attachment.savePath = this.subfolderPath;
      }
    }
    catch(e)
    {
      this.$store.dispatch('setErrorMessage', 'Impossible de récupérer les pièces jointes');
      console.log(e);
      return;
    }
    finally
    {
      this.isGettingAttachments = false;
    }

    this.showAttachmentPrompt = true;
    console.clear();
  }

  async saveAttachments()
  {
    const mail = Office.context.mailbox.item;
    this.isSavingAttachments = true;
    try
    {
      await this.saveAttachmentsOnly(this.$store.state.currentDossier, mail!, this.subfolderPath, this.attachments);
    }
    catch(e)
    {
      this.$store.dispatch('setErrorMessage', "Impossible d'enregistrer les pièces jointes");
      console.log(e);
      return;
    }
    finally
    {
      this.isSavingAttachments = false;
    }

    this.$store.commit('setSuccessMessage', "Pièces jointes enregistrées");
    this.showAttachmentPrompt = false;
  }

  async checkHasAttachments()
  {
    await this.promptForAttachments(this.SaveMode.MAIL);
  }

  async linkMail()
  {
    const mail = Office.context.mailbox.item;
    this.isLinking = true;
    try
    {
      await this.addMail(this.$store.state.currentDossier, mail!, this.subfolderPath, this.attachments, this.mailFilename);
    }
    catch(e)
    {
      this.$store.dispatch('setErrorMessage', "Impossible de lier le mail au dossier");
      console.log(e);
      return;
    }
    finally
    {
      this.isLinking = false;
    }

    this.showAttachmentPrompt = false;
    this.$router.push({ name: 'linked' });
  }

  updateAttachmentName(attachment: Attachment, name: string)
  {
    const index = this.attachments.findIndex((a) => a.name == attachment.name);
    this.attachments[index].name = name;
  }

  updateMailFilename(name: string)
  {
    this.mailFilename = sanitize(name);
  }

  updateAttachments(attachments: Attachment[])
  {
    this.attachments = attachments;
  }

  updateSubfolderPathFromNavigator(path: string)
  {
    this.subfolderPath = path;
  }

  hideAttachmentPrompt()
  {
    this.subfolderPath = "";
    this.showAttachmentPrompt = false

  }

  get hasAttachToMultipleDossiersCapability()
  {
    try
    {
      return this.$store.state.capabilities.includes('mail_attach_multiple_dossiers');
    }
    catch(e)
    {
      console.error(e);
      return false;
    }
  }
}
</script>

<style scoped lang="scss">
</style>
